import { getRouteApi } from '@tanstack/react-router';

import { EuropaceEventCard } from './EuropaceEventCard';
import { EUROPACE_PROCESS_EVENTS_DISCRIMINATORS } from '~/constants.ts';
import { useEuropaceProcessEvents } from '~/features/leadDetails/components/LeadSideInfo/ExternalServices/hooks/useEuropaceProcessEvents.ts';
import type { SchemaEuropaceEventsTableData } from '~/features/leadDetails/components/LeadSideInfo/ExternalServices/schemas/europaceProcessEventsData.ts';
import useLead from '~/features/leadDetails/hooks/useLead.ts';

type Props = {
    europaceOfferId?: string | null;
};

export const EuropaceProcessEventsTable: React.FC<Props> = ({ europaceOfferId }) => {
    const { useParams } = getRouteApi('/_app/leads_/details/$leadId');
    const { leadId } = useParams();
    const { data: lead } = useLead(leadId);
    const { data: europaceProcessEvents, isPending } = useEuropaceProcessEvents({ loanRequestId: lead?.id });
    if (isPending || europaceProcessEvents == null) {
        return null;
    }

    const preparedEventProcesses = europaceProcessEvents.events.process.map((event) => ({
        ...event,
        discriminator: EUROPACE_PROCESS_EVENTS_DISCRIMINATORS.PROCESS,
    }));
    const preparedEventOffers = europaceProcessEvents.events.offers.map((event) => ({
        ...event,
        discriminator: EUROPACE_PROCESS_EVENTS_DISCRIMINATORS.OFFER,
    }));

    const preparedEvents: Array<SchemaEuropaceEventsTableData> = [
        ...preparedEventProcesses,
        ...preparedEventOffers,
    ].sort((a, b) => {
        if (a.date && b.date) {
            return new Date(b.date).getTime() - new Date(a.date).getTime();
        }
        return 0;
    });

    const eventsToBeDisplayed = europaceOfferId
        ? preparedEventOffers.filter((event) => event.europaceOfferId === europaceOfferId || !event.europaceOfferId)
        : preparedEvents;

    return (
        <div className="flex flex-col gap-4">
            {eventsToBeDisplayed.map((event, index) => (
                <EuropaceEventCard key={`process-event-${index}`} payload={event} />
            ))}
        </div>
    );
};
